import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettyJson',
  standalone: true
})
export class PrettyJsonPipe implements PipeTransform {

  transform(value: any): string {
    if (!value) return '';

    if (typeof value === 'object' && !(value instanceof File || value instanceof Blob)) {
      try {
        return JSON.stringify(value, null, 2);
      } catch {
        return String(value);
      }
    }

    if (value instanceof File || value instanceof Blob) {
      return `File: ${value instanceof File ? value.name : 'Blob'} (${value.size} bytes)`;
    }

    if (typeof value === 'string') {
      let str = unescapeString(value);
      const trimmed = str.trim();

      // JSON
      if ((trimmed.startsWith('{') && trimmed.endsWith('}')) ||
        (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
        try {
          const obj = JSON.parse(trimmed);
          return JSON.stringify(obj, null, 2);
        } catch { }
      }

      // XML / HTML
      if (trimmed.startsWith('<') && trimmed.endsWith('>')) {
        return this.formatXml(trimmed);
      }

      return str;
    }

    return String(value);
  }

  private formatXml(xml: string): string {
    // Replace adjacent tags with newlines between them
    xml = xml.replace(/>\s*</g, '>\n<');

    let formatted = '';
    let indent = 0;
    const pad = (n: number) => '  '.repeat(n);

    xml.split('\n').forEach(line => {
      if (line.match(/^<\/[^>]+>/)) {
        indent = Math.max(indent - 1, 0);
      }

      formatted += pad(indent) + line.trim() + '\n';

      if (line.match(/^<[^!?\/][^>]*[^\/]>$/)) {
        indent++;
      }
    });

    return formatted.trim();
  }
}

function unescapeString(str: string): string {
  if (!str) return '';
  if (str.startsWith('"') && str.endsWith('"')) str = str.slice(1, -1);
  return str
    .replace(/\\r/g, '\r')
    .replace(/\\n/g, '\n')
    .replace(/\\"/g, '"')
    .replace(/\\t/g, '  ');
}
